export default defineNuxtRouteMiddleware((to, from) => {
  if (['/bp', '/bp/', '/'].includes(to.path)) {
    const nuxtApp = useNuxtApp()
    return nuxtApp.runWithContext(() => navigateTo({ path: '/login', query: to.query }))
  }
});
